import React, { useState } from 'react'
import styles from './NavBar.module.scss'
import { NavLink } from 'react-router-dom'

import dollar from "../../icons/dollar.svg"
import clipboard from "../../icons/clipboard.svg"
import flame from "../../icons/flame.svg"
import gear from "../../icons/gear.svg"
import person from "../../icons/person.svg"
// import location from "../../icons/location.svg";
import piechart from "../../icons/piechart.svg"
import tanker from "../../icons/tanker.svg"
import logo from '../../icons/logov2.svg'
import tank from '../../icons/terminal-icon.svg'
import { useAuth } from '../../context/AuthContext'

export interface HamburgerState {
    setMainMenuState(desiredState: boolean)
    setSubMenuState(desiredState: boolean)
    triggerLightHamburger()
    mainMenuState: boolean
    subMenuState: boolean
    lightHamburgerState: boolean
}

interface Props {
    hamburgerState: HamburgerState
}

interface NavItem {
    title: string
    icon: string
    url: string
}

const NavBar: React.FC<Props> = ({ hamburgerState }) => {
    const { isAuthenticated } = useAuth();

    const [navItems] = useState<NavItem[]>([
        { title: "Orders", icon: clipboard, url: "/orders" },
        { title: "Customers", icon: person, url: "/customers" },
        { title: "Carriers", icon: tanker, url: "/carriers" },
        { title: "Suppliers", icon: flame, url: "/suppliers" },
        { title: "Terminals", icon: tank, url: "/terminals" },
        { title: "Reports", icon: piechart, url: "/reports" },
        { title: "Pricing", icon: dollar, url: "/pricing" },
    ]);
    const [mobileNavIsOpen, setMobileNavIsOpen] = useState(false);

    const closeMobileMenu = () => {
        setMobileNavIsOpen(false);
    };

    const toggleMobileNav = () => {
        hamburgerState.setMainMenuState(!hamburgerState.mainMenuState);
    };

    const openLink = () => {
        hamburgerState.setMainMenuState(false);
        hamburgerState.setSubMenuState(true);
    };

    const renderNavItems = () => {
        return navItems.map((navItem, i) => (
            <li className={styles.NavBar__listItem} key={`${navItem.title}-${i}`}>
                <NavLink
                    onClick={openLink}
                    className={({ isActive }) =>
                        isActive
                            ? `${styles.NavBar__link__active} ${styles.NavBar__link}`
                            : styles.NavBar__link
                    }
                    to={navItem.url}
                >
                    <div className={styles.NavBar__icon__wrapper}>
                        <img
                            className={styles.NavBar__icon}
                            src={navItem.icon}
                            alt={`${navItem.title} icon`}
                        />
                    </div>
                    {navItem.title}
                </NavLink>
            </li>
        ));
    };

    if (!isAuthenticated) {
        return null;
    }

    return (
        <div className={styles.NavBar__wrapper}>
            <div className={`${styles.NavBar} ${hamburgerState.mainMenuState && styles.NavBar__mobileOpen}`}>
                <ul className={styles.NavBar__list}>

                    <li className={`${styles.NavBar__listItem} ${styles.NavBar__listItem__logo}`}>
                        <NavLink onClick={openLink.bind(this)} to="/">
                            <img className={styles.NavBar__logo} src={logo} alt="Logo" />
                        </NavLink>
                    </li>

                    <div className={styles.NavBar__listItemWrapper}>
                        {renderNavItems()}
                        <li className={`${styles.NavBar__listItem} ${styles.NavBar__listItem__lower}`}>
                            <NavLink
                                onClick={openLink.bind(this)}
                                className={({ isActive }) => isActive ? `${styles.NavBar__link__active} ${styles.NavBar__link}` : styles.NavBar__link}
                                to="/settings"
                            >
                                <div className={styles.NavBar__icon__wrapper}>
                                    <img className={styles.NavBar__icon} src={gear} alt="Settings icon" />
                                </div>
                                Settings
                            </NavLink>
                        </li>
                    </div>

                </ul>
            </div>

            <div onClick={toggleMobileNav.bind(this)}
                className={`${styles.NavBar__mobileTrigger} 
                                        ${hamburgerState.mainMenuState && styles.NavBar__mobileTrigger__close} 
                                        ${hamburgerState.lightHamburgerState && styles.NavBar__mobileTrigger__light}`}>
                <span></span>
                <span></span>
                <span></span>
            </div>

        </div>
    )
};

export default NavBar;